<div class="main-container" style="max-width: 100%">
  <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError">
    Error occurred
  </div>
  <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <mat-horizontal-stepper>
      <mat-step [stepControl]="formGeneral" label="General Settings">
        <div class="col-lg-6">
          <app-mat-checkbox-input [formControl]="getFormControl('isEnabled', formGeneral)" label="Enabled"
                                  name="isEnabled" [submitted]="submitted"
                                  *ngIf="hasEditAccess"></app-mat-checkbox-input>

          <app-mat-text-input [formControl]="getFormControl('name', formGeneral)" label="Name"
                              name="name" [submitted]="submitted"></app-mat-text-input>
          <app-mat-simple-select [formControl]="getFormControl('sourceName', formGeneral)" label="Report Type"
                                 name="role" [selectItems]="customReportsService.dataSources"
                                 [submitted]="submitted"></app-mat-simple-select>

          <div class="button-row">
            <button mat-raised-button matStepperNext type="button">Next</button>
          </div>
        </div>
      </mat-step>
      <mat-step [stepControl]="formTimeRange" label="Time Range">
        <div class="col-lg-6">
          <app-mat-simple-select [formControl]="getFormControl('timeRange', formTimeRange)" label="Time Range"
                                 name="role" [selectItems]="timeRanges"
                                 [submitted]="submitted"></app-mat-simple-select>

          <app-mat-simple-select *ngIf="(formGeneral.getRawValue()['sourceName'] || '').indexOf('V2') > -1"
                                 [formControl]="getFormControl('excludeDow', formTimeRange)"
                                 label="Exclude days of week"
                                 name="role" [selectItems]="daysOfWeek" [multiple]="true"
                                 [submitted]="submitted"></app-mat-simple-select>
        </div>
        <div class="button-row">
          <button mat-raised-button matStepperPrevious type="button">Back</button>
          <button mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </mat-step>
      <mat-step label="Filter Options">
        @if (formGeneral.get('sourceName')?.value !== ReportTypes.agentsLoginLogoutV2) {
          <div class="col-lg-6">
            <app-mat-phone-number-input [(ngModel)]="fitterByFromNumber" label="Include From Number (optional)"
                                        [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>

            <app-mat-phone-number-input [(ngModel)]="fitterByToNumber" label="Include To Number (optional)"
                                        [ngModelOptions]="{standalone: true}"></app-mat-phone-number-input>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroups
        || formGeneral.get('sourceName')?.value === ReportTypes.agentGroupsV2
        || formGeneral.get('sourceName')?.value === ReportTypes.agentsLoginLogoutV2) {
          <div class="col-lg-6">
            <app-options-card title="Include all Agent Groups" [options]="reportsService.groupsLookup"
                              [collapsed]="true"
                              [emptyIsAll]="true"
                              [(checkedOptions)]="checkedAgentGroupsOptions"
                              [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.huntGroups || formGeneral.get('sourceName')?.value === ReportTypes.huntGroupsV2) {
          <div class="col-lg-6">
            <app-options-card title="Include all Hunt Groups" [options]="reportsService.huntGroupsLookup"
                              [collapsed]="false"
                              [(checkedOptions)]="checkedHuntGroupsOptions"
                              [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.huntGroups
        || formGeneral.get('sourceName')?.value === ReportTypes.agentGroups
        || formGeneral.get('sourceName')?.value === ReportTypes.agentGroupsV2
        || formGeneral.get('sourceName')?.value === ReportTypes.huntGroupsV2
        || formGeneral.get('sourceName')?.value === ReportTypes.agentsLoginLogoutV2) {
          <div class="col-lg-6">
            <app-options-card title="Include All Agents" [options]="reportsService.extensionsLookup"
                              [collapsed]="true"
                              [emptyIsAll]="true"
                              [(checkedOptions)]="checkedAgentsOptions" [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.usersSummary
        || formGeneral.get('sourceName')?.value === ReportTypes.usersSummaryV2
        || formGeneral.get('sourceName')?.value === ReportTypes.callLogsV2) {
          <div class="col-lg-6">
            <app-options-card title="Select Extensions" [options]="reportsService.extensionsLookup"
                              [collapsed]="false"
                              [(checkedOptions)]="checkedExtensionsOptions"
                              [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.usersSummary
        || formGeneral.get('sourceName')?.value === ReportTypes.usersSummaryV2
        || formGeneral.get('sourceName')?.value === ReportTypes.callLogsV2) {
          <div class="col-lg-6">
            <app-options-card title="Select Departments" [options]="reportsService.departmentsNamesLookup"
                              [collapsed]="false"
                              [(checkedOptions)]="checkedDepartmentsOptions"
                              [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.callLogsV2) {
          <div class="col-lg-6">
            <app-options-card title="Select Groups & Other Accounts" [options]="reportsService.groupsAndOtherLookup"
                              [collapsed]="false"
                              [(checkedOptions)]="otherAccountsOptions"
                              [showSearchInput]="true"></app-options-card>
          </div>
        }
        @if (formGeneral.get('sourceName')?.value === ReportTypes.domainsSummary) {
          <div class="col-lg-6">
            <app-options-card title="Select Domains" [options]="customReportsService.domainsLookup"
                              [collapsed]="false"
                              [(checkedOptions)]="checkedDomainsOptions" [showSearchInput]="true"></app-options-card>
          </div>
        }
        <div class="button-row">
          <button mat-raised-button matStepperPrevious type="button">Back</button>
          <button mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </mat-step>
      <mat-step label="Export Options">
        <div class="export-container">
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroups
          || formGeneral.get('sourceName')?.value === ReportTypes.agentGroupsV2) {
            <div class="col-lg-4">
              <app-options-card title="Agent Groups Columns to export" [options]="exportAgentGroupsColumns"
                                [(checkedOptions)]="selectedAgentGroupsColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.huntGroups
          || formGeneral.get('sourceName')?.value === ReportTypes.huntGroupsV2) {
            <div class="col-lg-4">
              <app-options-card title="Hunt Groups Columns to export" [options]="exportHuntGroupsColumns"
                                [(checkedOptions)]="selectedHuntGroupsColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroups) {
            <div class="col-lg-4">
              <app-options-card title="Agents Columns to export" [options]="exportAgentsColumns"
                                [(checkedOptions)]="selectedAgentsColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentsLoginLogoutV2) {
            <div class="col-lg-6">
              <app-options-card title="Agents Login/Logout Columns to export" [options]="exportAgentsLoginLogoutColumns"
                                [(checkedOptions)]="selectedAgentsLoginLogoutColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.huntGroups) {
            <div class="col-lg-4">
              <app-options-card title="Agent Columns to export" [options]="exportHuntAgentsColumns"
                                [(checkedOptions)]="selectedHuntAgentsColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroupsV2) {
            <div class="col-lg-4">
              <app-options-card title="Agents Columns to export" [options]="exportAgentsV2Columns"
                                [(checkedOptions)]="selectedAgentsV2Columns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.huntGroupsV2) {
            <div class="col-lg-4">
              <app-options-card title="Agents Columns to export" [options]="exportHuntAgentsV2Columns"
                                [(checkedOptions)]="selectedHuntAgentsV2Columns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.usersSummary) {
            <div class="col-lg-4">
              <app-options-card title="Agents Columns to export" [options]="exportUsersSummaryColumns"
                                [(checkedOptions)]="selectedUsersSummaryColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.usersSummaryV2) {
            <div class="col-lg-4">
              <app-options-card title="Agents Columns to export" [options]="exportUsersSummaryV2Columns"
                                [(checkedOptions)]="selectedUsersSummaryV2Columns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.domainsSummary) {
            <div class="col-lg-4">
              <app-options-card title="Domain Columns to export" [options]="exportDomainsSummaryColumns"
                                [(checkedOptions)]="selectedDomainsSummaryColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroups
          || formGeneral.get('sourceName')?.value === ReportTypes.huntGroups) {
            <div class="col-lg-4">
              <app-options-card title="Call Logs Columns to export" [options]="exportCallLogsColumns"
                                [(checkedOptions)]="selectedCallLogsColumns"></app-options-card>
            </div>
          }
          @if (formGeneral.get('sourceName')?.value === ReportTypes.agentGroupsV2
          || formGeneral.get('sourceName')?.value === ReportTypes.huntGroupsV2
          || formGeneral.get('sourceName')?.value === ReportTypes.callLogsV2) {
            <div class="col-lg-4">
              <app-options-card title="Call Logs Columns to export" [options]="exportCallLogsV2Columns"
                                [(checkedOptions)]="selectedCallLogsV2Columns"></app-options-card>
            </div>
          }
        </div>
        <div class="button-row">
          <button mat-raised-button matStepperPrevious type="button">Back</button>
          <button mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </mat-step>
      <mat-step [stepControl]="recurringForm" label="Schedule Options">
        <app-mat-rrule-form-group [formGroup]="recurringForm" [submitted]="submitted" [userTimezone]="userTimezone"
                                  (onRRuleChanged)="onRRuleChanged($event)"></app-mat-rrule-form-group>
        <div class="button-row">
          <button mat-raised-button matStepperPrevious type="button">Back</button>
          <button mat-raised-button matStepperNext type="button">Next</button>
        </div>
      </mat-step>
      <mat-step [stepControl]="formRecipients" label="Recipients">
        <div class="col-lg-6">
          <div class="form-group">
            <app-mat-multiselect [formControl]="getFormControl('recipients', formRecipients)"
                                 label="Where to send report?"
                                 name="recipients"
                                 placeholder="Search for recipient"
                                 style="flex: auto"
                                 [autoCompleteValues]="allRecipients"
                                 [submitted]="submitted">
            </app-mat-multiselect>
          </div>
        </div>

        <div class="button-row">
          <button mat-raised-button matStepperPrevious type="button">Back</button>
          @if (hasEditAccess || hasViewAccess) {
            <button mat-raised-button color="primary" type="submit" [promiseBtn]="buttonSubmitPromise">Save</button>
          }
          @if (hasDeleteAccess && model.id && model.id !== 'new') {
            <button mat-raised-button color="warn" type="button" matTooltip="Remove report" class="only-icon"
                    (click)="onDeleteClick()">
              <mat-icon>delete</mat-icon>
            </button>
          }
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</div>
